<div class="cc-content-wrapper lobby-wrapper">
  <div class="appointment-status"> 
  <div class="cc-action-panel row">
    <div class="central-view-filters row">
      <div class="col-md-6">       
        <app-location-selector [isDisableParentClick]="true" [isLobby]="true" [selectableTypes]="[5]" labelText="{{'_Lobby_Signed_In_Out_Location_Text_' | translate }}"
          [hoverText]="selectorHoverMessage | translate" [selectorDisabled]="disableSelector || disableSelectorNoBranch" [dispatchStateEvent]="false"
          (onChange)="handleLocationData($event)" [selectedLocationId]="locationId"
          [selectedLocationName]="selectedLocationName" [hideBranchLess]="true" [isIncludeFloatLocation]="false"></app-location-selector>
      </div>
    </div>    
    <div class="cc-search">
      <input class="form-control" placeholder="{{'_General_Search_Text_' | translate }}" [(ngModel)]="searchFilter" (keydown.enter)="setSearchFilter()" />
      <button [ngClass]="{ 'show-btn': searchFilter !== '' }" class="cc-close-btn" (click)="removeSearchFilter()">
        <span class="fas fa-times"></span>
      </button>
      <button class="cc-search-btn" (click)="removeSearchFilter()">
        <span class="fas fa-search"></span>
      </button>
    </div>
  </div>

  <div class="grid-view lobby-apointment-queue-grid-wrapper">
    <kendo-grid [pageable]="true" [data]="gridView" [pageSize]="pageSize" [skip]="skip"  [sortable]="{ allowUnsort: false, mode: 'single' }" [sort]="sort"
      scrollable="scrollable" (pageChange)="pageChange($event)" (sortChange)="sortChange($event)">
      <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
      <kendo-grid-column field="appointmentTypeId" title="{{'_General_Type_Text_' | translate }}" [sortable]="false"
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button *ngIf="dataItem.appointmentTypeId === 1" class="cc-icon-btn" title="{{'_General_InPerson_Appointment_Text_' | translate }}">
            <img class="in-person-appointment-icon" src="assets/images/icon/in-person-appointment.svg" alt=""/>
          </button>
          <button *ngIf="dataItem.appointmentTypeId === 2" class="cc-icon-btn" title="{{'_General_Phone_Appointment_Text_' | translate }}">
            <span class="fas fa-phone"></span>
          </button>
          <button *ngIf="dataItem.appointmentTypeId === 5" class="cc-icon-btn" title="{{'_General_Virtual_Appointment_Text_' | translate }}">
            <img class="virtual-appointment-icon" src="assets/images/icon/virtual-appointment.svg" alt=""/>
          </button>
          <!-- <button *ngIf="dataItem.appointmentTypeId === 4" class="cc-icon-btn" title="Wait Smarter">
            <span class="fas fa-mobile-alt"></span>
          </button> -->
          <button *ngIf="dataItem.spanishSpeakerRequested" class="cc-icon-btn" title="{{'_General_Notes_ES_Speaker_Text_' | translate }}">
            <img class="spanish-speaker-icon" src="assets/images/icon/spanish-speaker-preferred.svg" alt=""/>
          </button>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="confirmationNumber" title="{{'_General_Confirmation_Text_' | translate }} #" [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="firstName" title="{{'_General_User_First_Name_Text_' | translate }}" [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="lastName" title="{{'_General_User_Last_Name_Text_' | translate }}" [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="appointmentServiceRequests" title="{{'_General_Request(s)_Text_' | translate }}"
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button *ngIf="dataItem.appointmentServiceRequests.length > 1" class="cc-icon-btn"
            (click)="serviceRequestedExpandHandler(dataItem)">
            <span class="fas fa-plus"></span>
          </button>
          <span *ngIf="dataItem.appointmentServiceRequests.length >= 1">
            {{ dataItem.appointmentServiceRequests[0] }}
          </span>
          <!-- <span *ngIf="dataItem.appointmentServiceRequests.length == 0">
            N/A
          </span> -->
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="personRequested" title="{{'_General_Report_Staff_Requested_Text_' | translate }}"
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>

          <span *ngIf="dataItem.personRequested !== ' '">
            {{ dataItem.personRequested}}
          </span>
          <span *ngIf="dataItem.personRequested === ' '">
            N/A
          </span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="notes" title="{{'_General_Notes_Text_' | translate }}" [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="appointmentTime" title="{{'_Appointment_Status_Grid_Time_Text_' | translate }}" [headerStyle]="{ 'font-weight': 'bold'}">
        <!--Need to append 'z' to the time below, otherwise the correct timezone conversion doesnt happen -->
        <!--Ref: https://tc39.es/ecma262/#sec-date.parse -->
        <ng-template kendoGridCellTemplate let-dataItem>
          <!-- {{ dataItem.appointmentTime + 'z' | date: 'hh:mm a' : locationTimeOffset }} -->
          {{
            dataItem.appointmentLocalTime        
            | date:'h:mm a'
            }} 
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="status" title="{{'_General_Status_Text_' | translate }}" [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <p>
            {{
            (dataItem.status
            | AppointmentStatusPipe) | translate
            }}
          </p>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="{{'_General_Button_Action_Text_' | translate }}" [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}">
        <ng-template kendoGridCellTemplate let-item>
          <div class="cell-items-center">
            <button class="cc-icon-btn" title="{{'_General_CheckIn_Text_' | translate }}" (click)="showCheckInConfirmation(item)">
              <span class="far fa-calendar-check"></span>
            </button>
            <button *ngIf="item.appointmentSourceId !== 4" class="cc-icon-btn" title="{{'_General_No_Show_Text_' | translate }}"
              (click)="showNoShowConfirmation(item)">
              <span class="fas fa-ban"></span>
            </button>
            <button *ngIf="item.appointmentSourceId !== 4 && (userPermissionList?.includes(46))" class="cc-icon-btn"
              title="{{'_General_Button_Edit_Text_' | translate }}" (click)="editACAppointmet(item)">
              <span class="fas fa-pen"></span>
            </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>     
    </kendo-grid>
  </div>
  </div>
</div>


<kendo-dialog id="serviceDialogModel" title="{{
    selectedAppointmentRecord.firstName +
      ' ' +
      selectedAppointmentRecord.lastName
  }} {{'_General_Request(s)_Text_' | translate }}: " *ngIf="openProductServiceDialog" (close)="closeProductServiceDialog()" [minWidth]="250"
  [width]="600">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div class="psPanel">
    <div class="ps-list">
      <ul>
        <li *ngFor="
            let field of selectedAppointmentRecord.appointmentServiceRequests;
            let index = index
          ">
          {{ field }}
        </li>
      </ul>
    </div>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button kendoButton class="btn btn-primary" kendoButton (click)="closeProductServiceDialog()" primary="true">
      {{'_General_Button_Close_Text_' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog> 

<app-modalpopup header="{{'_Appointment_Status_Grid_CheckIn_Header_Text_' | translate}} " [(dialogOpened)]="openCheckInConfirmationDialog" [isInfo]="false"
  actionNoLabel="{{'_General_Action_Label_No_Text_' | translate }}" actionYesLabel="{{'_Appointment_Status_Grid_CheckIn_Text_'| translate }}" 
  [message]=" selectedAppointmentRecord ? checkinInfo1Text + ' ' + selectedAppointmentRecord.confirmationNumber + ' ' + checkinInfo2Text : '' " 
      (submitted)="closeCheckInConfirmationDialog('yes')" (cancelled)="closeCheckInConfirmationDialog('no')">
</app-modalpopup> 

<app-modalpopup header="{{'_Appointment_Status_Grid_Change_Status_Header_Text_' | translate}} " [(dialogOpened)]="openNoShowConfirmationDialog" [isInfo]="false"
  actionNoLabel="{{'_General_Action_Label_No_Text_' | translate }}" actionYesLabel="{{'_General_Action_Label_Yes_Text_' | translate }}" 
  [message]=" selectedAppointmentRecord ? markInfo1Text + ' ' + selectedAppointmentRecord.confirmationNumber + ' ' + markInfo2Text : '' "
  (submitted)="closeNoShowConfirmationDialog('yes')" (cancelled)="closeNoShowConfirmationDialog('no')">
</app-modalpopup>
